import React from 'react';
import { IconFunctionalShow16 } from '@cian/ui-kit-design-tokens/icons';

import { IconWithCount } from '../../../IconWithText';
import { IJournalAttributesSchema } from '../../../../repositories/journal/entities/journal/JournalAttributesSchema';

interface INumViews {
  /** Количество просмотров */
  children?: IJournalAttributesSchema['numViews'];
}

/**
 * Количество просмотров
 */
export const NumViews = ({ children }: INumViews) =>
  children ? <IconWithCount count={children} icon={<IconFunctionalShow16 />} /> : null;
